import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function ArrowRightIcon({ color = "purple" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 12L13 6M19 12L13 18M19 12H5"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
